import { Colors } from "../../../config/default";
import {
  FONT_SIZE_LARGE,
  FONT_SIZE_SMALL,
} from "../../../constants/appConstants";

export const styles = {
  headerText: {
    fontFamily: "Nunito",
    fontWeight: 600,
    width: "100%",
    color: Colors.BLACK,
    fontSize: FONT_SIZE_LARGE,
  },
  listContainer: {
    marginTop: "1rem",
    backgroundColor: Colors.WHITE,
    padding: "1rem",
    borderRadius: "10px",
    overflowX: "auto",
    display: "flex",
    flexDirection: "row",
    flexWrap: "wrap",
  },
  columnBox: {
    display: "flex",
    flexDirection: "column",
    boxSizing: "border-box",
    overflow: "hidden",
  },
  columnHeader: {
    fontFamily: "Nunito",
    fontWeight: 600,
    color: Colors.BLACK,
    fontSize: { xs: FONT_SIZE_SMALL, sm: FONT_SIZE_LARGE },
    marginBottom: "0.5rem",
  },
  fileText: {
    marginTop: "0.5rem",
    fontFamily: "Nunito",
    fontWeight: 400,
    color: Colors.DARK_GRAY,
    fontSize: { xs: FONT_SIZE_SMALL, sm: FONT_SIZE_LARGE },
    display: "flex",
    alignItems: "center",
    overflow: "hidden",
  },
  fileName: {
    textTransform: "none",
    color: Colors.BLUE_COLOR,
    fontSize: { xs: FONT_SIZE_SMALL, sm: FONT_SIZE_LARGE },
  },

  checkbox: {
    width: "40px",
    height: "40px",
  },
  selectColumn: {
    minWidth: "100px",
    flex: "0 0 100px",
    position: "sticky",
    top: 0,
    zIndex: 1,
    backgroundColor: "background.paper",
  },
  titleColumn: {
    position: "sticky",
    top: 0,
    zIndex: 1,
    backgroundColor: "background.paper",
  },
  typeColumn: {
    flex: 1,
    position: "sticky",
    top: 0,
    zIndex: 1,
    backgroundColor: "background.paper",
  },
  pathColumn: {
    flex: 1,
    position: "sticky",
    top: 0,
    zIndex: 1,
    backgroundColor: "background.paper",
  },
  actionsColumn: {
    flex: 1,
    position: "sticky",
    top: 0,
    zIndex: 1,
    backgroundColor: "background.paper",
  },
  tableHeader: {
    fontWeight: "bold",
    fontSize: "1rem",
  },
  checkboxCell: {
    width: "60px",
    textAlign: "center",
  },
  pathCell: {
    fontSize: { xs: FONT_SIZE_SMALL, lg: FONT_SIZE_LARGE },
  },
  pathDataCell: {
    maxWidth: "300px",
  },

  pathText: {
    overflowWrap: "break-word",
    wordWrap: "break-word",
    fontSize: { xs: FONT_SIZE_LARGE },
    "&:hover": {
      cursor: "pointer",
    },
  },
  actionIcons: {
    display: "flex",
    gap: "0.5rem",
    alignItems: "center",
  },

  uploadContainer: {
    display: "flex",
    flexDirection: "column",
    marginTop: "1rem",
    backgroundColor: Colors.WHITE,
    padding: "1rem",
    borderRadius: "10px",
    justifyContent: "center",
    alignItems: "center",
  },
  dropzone: {
    backgroundColor: Colors.WHITE,
    marginTop: ".5rem",
    marginBottom: ".5rem",
    borderRadius: "10px",
    display: "flex",
    alignItems: "center",
    width: "100%",
    height: "40px",
    justifyContent: "center",
    cursor: "pointer",
  },
  uploadBox: {
    border: "2px dashed #ccc",
    borderRadius: "4px",
    padding: "1rem",
    textAlign: "center",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    fontSize: "3rem",
    marginBottom: "0.5rem",
    color: Colors.DIM_LIGHT_GRAY,
    cursor: "pointer",
  },
  uploadText: {
    fontSize: "1rem",
    color: Colors.DIM_LIGHT_GRAY,
    cursor: "pointer",
  },

  uploadIcon: {
    fontSize: "3rem",
    marginBottom: "0.5rem",
    color: Colors.DIM_LIGHT_GRAY,
    cursor: "pointer",
  },
};
